import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import OrderPage from '../components/OrderPage';

class OrderOfAgent extends Component {
  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.agentSites(callback)
      },
      fetchOrders: (params, callback) => {
        DataFetcher.agentOrders(params, {
          success: callback
        })
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(params, {
          success: callback
        })
      },
      sendGift: (params, callback, completed) => {
        DataFetcher.createGift(params, {
          success: callback,
          completed
        })
      },
      refund: (params, callback) => {
        DataFetcher.agentRefund(params, {
          success: callback
        })
      },
    }

    return <OrderPage {...pageProps}/>
  }
}

export default OrderOfAgent;


// WEBPACK FOOTER //
// ./src/modules/OrderOfAgent.js